import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/badgeStyle';
import classNames from 'classnames';
import { BodyS } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBadgeProps {
	color?: types.theme.badgeColor;
	children?: string | React.ReactElement;
	filled?: boolean;
	hexColor?: string;
	className?: string;
	maxWidth?: number;
}

export default function Badge({ color, children, filled, hexColor, className, maxWidth }: IBadgeProps) {
	const classes = useStyles();

	const dotClasses = classNames({
		[classes.dot]: true,
		[classes[color]]: true,
		[classes.dotHidden]: filled,
	});

	const badgeClasses = classNames({
		[`${className}`]: !!className,
		[classes.badge]: !filled,
		[classes[color]]: filled,
		[classes.filledBadge]: filled,
	});

	return (
		<div className={badgeClasses} style={{ backgroundColor: hexColor, maxWidth: `${maxWidth}px` }}>
			<span className={dotClasses} />
			{typeof children === 'string' ? <BodyS color="primary-dark">{children}</BodyS> : children}
		</div>
	);
}
